<a
    class="fw:semibold c:grey-1"
    [routerLink]="['/', 'portal', 'meine-vertraege', contract()?.id]"
>
    <i ctrlIcon="chevron_left"></i> <span class="fs:s">Zurück zur {{ product()?.title }}</span>
</a>

@let dmg = damage();

<h1 class="c:blue-700">Schadensmeldung</h1>
@if (justSubmitted()) {
    <div class="portal-card just-submitted">
        <p>
            Deine Meldung wurde gespeichert. Wir werden sie so schnell wie möglich bearbeiten und dich per E-Mail über
            die Vorgänge informieren.
        </p>
        <p class="m-0">
            Du kannst den Status deines Berichts jederzeit im Kundenportal einsehen. Wähle hierzu auf dem Dashboard den
            Vertrag aus und klicke anschließend auf "Schadensmeldungen", um alle laufenden und abgeschlossenen Meldungen
            für diesen Vertrag zu sehen.
        </p>
    </div>
}
<dl class="portal-card">
    <div class="grid-container">
        <app-portal-widget-details
            class="g-6"
            heading="Erstellungsdatum"
            [detail]="dmg.createdAt | date: 'dd.MM.yyyy'"
        ></app-portal-widget-details>
        <app-portal-widget-details
            class="g-6"
            heading="Stand"
            [icon]="dmg.state === damageState.COMPLETED ? 'circle_check' : 'circle'"
            [detail]="dmg.stateDescription"
            [iconClass]="iconColor() + ' fs:l'"
        ></app-portal-widget-details>
    </div>
</dl>

<dl class="portal-card details">
    @if (dmg.damageDate || dmg.location) {
        <div class="grid-container">
            @if (dmg.damageDate) {
                <app-portal-widget-details
                    class="g-6"
                    heading="Schadensdatum"
                    [detail]="dmg.damageDate | date: 'dd.MM.yyyy'"
                ></app-portal-widget-details>
            }
            @if (dmg.location) {
                <app-portal-widget-details
                    class="g-6"
                    heading="Ort"
                    [detail]="dmg.location"
                ></app-portal-widget-details>
            }
        </div>
    }
    @if (dmg.damageDescription) {
        <app-portal-widget-details
            heading="Schadensbeschreibung"
            [detail]="dmg.damageDescription"
        ></app-portal-widget-details>
    }
    @if (dmg.eventDescription) {
        <app-portal-widget-details
            heading="Hergang"
            [detail]="dmg.eventDescription"
        ></app-portal-widget-details>
    }
</dl>

<h2 class="fw:light c:blue-700 m-4:b">Beigefügte Dokumente</h2>

@if (attachmentsPending()) {
    <div class="pending-attachment-list m-16:v md:m-24:v">
        <app-placeholder-card />
        <app-placeholder-card />
        <app-placeholder-card />
    </div>
} @else {
    <app-attached-file-list
        [initialDocuments]="attachments()"
        [insuranceTypeId]="contract().insuranceType.id"
        [damageReportId]="dmg.id"
        [contract]="contract()"
    ></app-attached-file-list>
}
